import { createContext, useContext, useEffect, useState } from "react";

// Türkçe kategori/etiket adlarının İngilizce karşılıkları (DB değerleri Türkçe kalır)
const NAMES_EN = {
  "Ana Sayfa": "Home",
  "Hakkımızda": "About Us",
  "Sertifikalar": "Certificates",
  "Yapay Kaplama": "Engineered Veneer",
  "Kaplama": "Veneer",
  "Doğal Kaplama": "Natural Veneer",
  "Doğal Ahşap Kaplama": "Natural Wood Veneer",
  "Ahşap Kaplama": "Wood Veneer",
  "Kök Kaplama": "Burl Veneer",
  "Kaburga Kaplama": "Crown Cut Veneer",
  "Piramit Kaplama": "Pyramid Veneer",
  "Papel Kaplama": "Papel Veneer",
  "Piramit": "Pyramid",
  "Normal (Yapay)": "Standard (Engineered)",
  "Normal": "Standard",
  "3D Yüzey": "3D Surface",
  "Kereste": "Timber",
  "Ahşap Kereste": "Timber",
  "Boyalı Kaplama": "Dyed Veneer",
  "Boyalı Ahşap Kaplama": "Dyed Wood Veneer",
  "Kontrplak": "Plywood",
  "Ahşap Kontrplak": "Plywood",
  "Linea Serisi": "Linea Series",
  "Vinterio Serisi": "Vinterio Series",
  "Doğal": "Natural",
  "Kök": "Burl",
  "Kaburga": "Crown Cut",
  "Afrika": "Africa",
  "Amerika": "America",
  "Avrupa": "Europe",
  "Uzak Doğu": "Far East",
  "Açık": "Light",
  "Orta": "Medium",
  "Koyu": "Dark",
  "Hareli": "Crown (Hareli)",
  "Freze": "Quarter (Freze)",
  "Janjanlı": "Fiddleback (Janjan)",
  "Pomela": "Pomele (Pomela)",
  "Papel": "Papel",
  "Tümü": "All",
  "Bölge": "Region",
};

const STR = {
  tr: {
    nav: { contact: "İletişim", searchProducts: "Ürün Ara", searchAria: "Ürün ara" },
    common: {
      products: "ürün",
      productsUpper: "Ürün",
      noImage: "Görsel yok",
      loading: "Yükleniyor...",
      close: "Kapat",
    },
    hero: {
      note1:
        "Sitemizdeki görseller temsilidir ve ürünlerimizin gerçek kalitesini tam olarak yansıtmayabilir. Kalitemizden emin olabilirsiniz; detaylı ürün incelemesi ve numune talepleriniz için ",
      contactLink: "iletişime geçin",
      discover: "Ormanımızı Keşfet",
    },
    quality: {
      note:
        "Görseller temsilidir ve ürünlerimizin gerçek kalitesini tam olarak yansıtmayabilir. Kalitemizden emin olabilirsiniz; detaylı ürün incelemesi ve numune talepleriniz için ",
      contact: "iletişime geçin",
    },
    manifesto: {
      label: "Hakkımızda",
      headingPre: "Malzemeye duyulan ",
      headingItalic: "saygıyla",
      headingPost: " inşa edildi.",
      chapters: [
        { num: "01", title: "Biz Kimiz?", body: "İnter Orman, dünyanın en kaliteli ahşap ürünlerini sizlerin beğenisine sunan ve kaliteyi önemseyen bir firmadır. Çevreye duyarlı, sosyal, kültürel ve düşünsel değerlerimizin bütünlüğüyle oluşturduğumuz çizgimizle evrensel ölçülerde bir firma olma yolunda kendimizden emin adımlarla ilerliyoruz." },
        { num: "02", title: "Misyonumuz", body: "Globalleşen günümüz dünyasında öncü olabilmek; siz müşterilerimize istek ve ihtiyaçlarınız doğrultusunda kaliteli ürünler ve pazar stratejileri sunarak alım-satım süreçlerini rekabetçi, hızlı, kolay, güvenilir ve verimli hale getirip sizleri rakiplerinizin karşısında güçlü konuma getirebilmektir." },
        { num: "03", title: "Amacımız", body: "İnter Orman Ürünleri olarak amacımız sağlam, dekoratif ve uzun ömürlü malzemeleri zengin çeşitlilik içinde ihtiyaç duyulduğu an sizlere sunmaktır. İthal ettiğimiz ürünlerimizin var olan standartlar üzerinde ve stoklu olarak bulundurulması en önemli çalışma prensibimizdir. Projelerinizde, bilgi ve deneyimlerimizden yararlanarak hızlı ve zamanında teslimatla beklentilerinizi karşılayacak ideallere ulaştığımızı ve bu çizgide devamlı olarak kendimizi geliştirmeye devam ettiğimizi mutlulukla ifade edebiliriz." },
      ],
      stats: [
        { value: "2.500.000m²+", label: "Kaplama" },
        { value: "40+", label: "Yıllık Tecrübe" },
        { value: "%100", label: "Kalite" },
      ],
    },
    yacht: {
      label: "Deniz & Zanaat",
      headingPre: "Denizlerin tercihi ",
      headingItalic: "Birmanya Teak",
      caption: "Okyanusa meydan okuyan zanaat",
      teakTitle: "Birmanya Teak",
      teakDesc: "Suya ve zamana karşı efsanevi dayanıklılığıyla, dünyanın en prestijli yat güvertelerinin klasik ahşabı. Sıcak altın tonları ve ince damarıyla zarafeti güce taşır.",
      cta: "Kaplamayı İncele",
    },
    veneerShowcase: {
      label: "Zanaat & Doku",
      headingPre: "Her levha, doğanın ",
      headingItalic: "imzasını",
      headingPost: " taşır.",
      desc: "Renk, damar ve dokunun sonsuz uyumu. Yüzlerce ahşap türünü, mekânlarınıza karakter katan premium kaplamalara dönüştürüyoruz.",
      cta: "Koleksiyonu Keşfet",
    },
    kaplamaShowcase: {
      label: "Doğal Kaplama Serileri",
      headingPre: "Kesim biçimine göre ",
      headingItalic: "kaplama",
      headingPost: ".",
      desc: "Doğal, kök ve piramit kaplama serilerimizi keşfedin; her biri ahşabın karakterini farklı bir kesimle ortaya koyar.",
    },
    yapayShowcase: {
      label: "Yapay Kaplama Serileri",
      headingPre: "Yüzeye göre ",
      headingItalic: "yapay kaplama",
      headingPost: ".",
      desc: "Düz ve üç boyutlu yüzey serilerimizi keşfedin; zengin renk ve desen seçenekleriyle mekânlarınıza modern bir karakter katın.",
    },
    keresteShowcase: {
      label: "Bölgelere Göre Kereste",
      headingPre: "Dünyanın dört bir yanından ",
      headingItalic: "ahşap",
      headingPost: ".",
      desc: "Afrika'dan Uzak Doğu'ya, dört kıtadan seçilmiş kereste çeşitlerimizi bölgesine göre keşfedin.",
    },
    featured: {
      label: "Koleksiyon",
      headingPre: "Ürün ",
      headingItalic: "gruplarımız",
      dragHint: "Sürükleyin veya kaydırın",
      viewAll: "Tümünü Gör",
    },
    contact: {
      label: "İletişim",
      headingPre: "Birlikte ",
      headingItalic: "çalışalım.",
      email: "E-posta",
      phone: "Telefon",
      whatsapp: "WhatsApp",
      address: "Adres",
      openMap: "Haritada Aç",
      waMessage: "Merhaba, ürünleriniz hakkında bilgi almak istiyorum.",
      formTitle: "Bize Yazın",
      formDesc: "Talebinizi iletin, en kısa sürede size dönüş yapalım.",
    },
    thanks: {
      label: "Mesajınız Alındı",
      heading: "Teşekkür ",
      headingItalic: "Ederiz",
      greeting: (name) => (name ? `Sayın ${name},` : ""),
      body: "Talebiniz bize güvenle ulaştı. Ekibimiz mesajınızı inceliyor; en kısa sürede size dönüş yapacağız.",
      note: "Acil talepleriniz için bize telefon veya WhatsApp üzerinden de ulaşabilirsiniz.",
      home: "Ana Sayfaya Dön",
      explore: "Ürünleri Keşfet",
      whatsapp: "WhatsApp ile Yazın",
    },
    trust: {
      label: "Güven & Kalite",
      heading: "Belgeli ",
      headingItalic: "Kalite",
      desc: "FSC sertifikalı tedarik zincirimiz ve tescilli markalarımızla, her ürünümüzün arkasında belgelenmiş bir kalite güvencesi vardır.",
      cta: "Sertifikaları Görüntüle",
      p1t: "FSC Sertifikalı",
      p1d: "Sorumlu ormancılıkla yönetilen kaynaklardan sertifikalı tedarik.",
      p2t: "Tescilli Markalar",
      p2d: "İnter Orman ve Vinterio, tescilli marka güvencesiyle sunulur.",
      p3t: "İthalat & İhracat",
      p3d: "Uzak Doğu'dan Avrupa'ya uzanan güçlü tedarik ve dağıtım ağı.",
      p4t: "Kalite Kontrolü",
      p4d: "Her parti, sevkiyat öncesi titiz kalite kontrolünden geçer.",
    },
    form: {
      name: "Adınız",
      namePh: "Adınızı girin",
      email: "E-posta",
      emailPh: "ornek@eposta.com",
      message: "Mesajınız",
      messagePh: "Talebinizi buraya yazın...",
      send: "Mesaj Gönder",
      sending: "Gönderiliyor...",
      fillAll: "Lütfen tüm alanları doldurun.",
      success: "Mesajınız alındı. En kısa sürede dönüş yapacağız.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
    },
    footer: {
      tagline: "Ahşap Kaplama İthalat",
      certificates: "Sertifikalar",
      rights: "Tüm hakları saklıdır.",
      admin: "Yönetim",
      kvkk: "Kişisel Verileri Saklama ve İmha Politikası",
    },
    search: {
      label: "Ürün Ara",
      placeholder: "Ürün adı, kategori veya seri yazın...",
      triggerText: "Ürün arayın — Meşe, Ceviz, Teak...",
      triggerBtn: "Ara",
      loading: "Ürünler yükleniyor...",
      searchIn: (n) => `${n} ürün içinde arayın`,
      results: (n, plus) => `${n} sonuç${plus ? "+" : ""}`,
      noResults: (q) => `"${q}" için sonuç bulunamadı. Farklı bir anahtar kelime deneyin.`,
    },
    lightbox: {
      special: "Özel Koleksiyon",
      noDesc: "Bu ürün için henüz açıklama eklenmedi.",
      quote: "Teklif Al",
      pdf: "PDF İndir",
      quoteSub: "Bu ürün için hızlıca teklif talebinde bulunun.",
      quoteSubPlywood: "Bu kontrplak için hızlıca teklif talebinde bulunun.",
      waButton: "WhatsApp ile Teklif Al",
      waSelect: "WhatsApp hattını seçin",
      orForm: "veya formu doldurun",
      direct: "Doğrudan iletişim",
      waMessage: (name) => `Merhaba, "${name}" ürünü için teklif almak istiyorum.`,
      quotePrefill: (name) => `Teklif talebi: ${name}`,
      zoomIn: "Dokuyu incele",
      zoomOut: "Uzaklaştır",
    },
    category: {
      products: "Ürünler",
      tone: "Renk Tonu",
      cut: "Kesim",
      empty: "Bu kategoride henüz ürün eklenmedi.",
      noResults: "Bu seçime ait ürün bulunamadı.",
    },
    certs: { empty: "Sertifikalar yakında eklenecek." },
    kontrplak: {
      heroSub: "Ahşap Kontrplak",
      heroTitle: "Kontrplak",
      heroDesc: "Hafif, dayanıklı ve marin sınıfı kontrplak çeşitleri — projeleriniz için en uygun çözümü seçin.",
      compareLabel: "Hızlı Karşılaştırma",
      compareHeading: "Hangi kontrplak size uygun?",
      thType: "Tür",
      thWeight: "Ağırlık",
      thWater: "Su Direnci",
      thSize: "Standart Ölçü",
      size: "Ölçü",
      features: "Özellikler",
      uses: "Kullanım Alanları",
    },
  },
  en: {
    nav: { contact: "Contact", searchProducts: "Search Products", searchAria: "Search products" },
    common: {
      products: "products",
      productsUpper: "Products",
      noImage: "No image",
      loading: "Loading...",
      close: "Close",
    },
    hero: {
      note1:
        "The images on our site are representative and may not fully reflect the true quality of our products. You can be assured of our quality; for detailed product inspection and sample requests, please ",
      contactLink: "get in touch",
      discover: "Explore Our Forest",
    },
    quality: {
      note:
        "Images are representative and may not fully reflect the true quality of our products. You can be assured of our quality; for detailed product inspection and sample requests, please ",
      contact: "get in touch",
    },
    manifesto: {
      label: "About Us",
      headingPre: "Built with ",
      headingItalic: "respect",
      headingPost: " for the material.",
      chapters: [
        { num: "01", title: "Who We Are", body: "İnter Orman is a company that values quality, offering the world's finest wood products. With a philosophy built on environmental awareness and the integrity of our social, cultural and intellectual values, we advance confidently toward becoming a company of universal standards." },
        { num: "02", title: "Our Mission", body: "To be a pioneer in today's globalizing world; to offer our customers quality products and market strategies tailored to your needs, making trading processes competitive, fast, easy, reliable and efficient — and positioning you strongly against your competitors." },
        { num: "03", title: "Our Goal", body: "At İnter Orman Ürünleri, our goal is to offer durable, decorative and long-lasting materials in rich variety, exactly when you need them. Keeping our imported products in stock and above existing standards is our most important working principle. Drawing on our knowledge and experience, we are proud to meet your expectations with fast, on-time delivery — and to keep improving ourselves along this line." },
      ],
      stats: [
        { value: "2,500,000m²+", label: "Veneer" },
        { value: "40+", label: "Years of Experience" },
        { value: "100%", label: "Quality" },
      ],
    },
    yacht: {
      label: "Sea & Craft",
      headingPre: "The choice of the seas: ",
      headingItalic: "Burmese Teak",
      caption: "Craftsmanship that defies the ocean",
      teakTitle: "Burmese Teak",
      teakDesc: "The classic wood of the world's most prestigious yacht decks, with legendary resistance to water and time. Its warm golden tones and fine grain carry elegance into strength.",
      cta: "View the Veneer",
    },
    veneerShowcase: {
      label: "Craft & Texture",
      headingPre: "Every sheet carries nature's ",
      headingItalic: "signature",
      headingPost: ".",
      desc: "An endless harmony of color, grain and texture. We transform hundreds of wood species into premium veneers that bring character to your spaces.",
      cta: "Explore the Collection",
    },
    kaplamaShowcase: {
      label: "Natural Veneer Series",
      headingPre: "Veneer by ",
      headingItalic: "cut",
      headingPost: ".",
      desc: "Discover our natural, burl and pyramid veneer series; each reveals the character of wood through a different cut.",
    },
    yapayShowcase: {
      label: "Engineered Veneer Series",
      headingPre: "Engineered veneer by ",
      headingItalic: "surface",
      headingPost: ".",
      desc: "Discover our flat and 3D surface series; add modern character to your spaces with rich color and pattern options.",
    },
    keresteShowcase: {
      label: "Timber by Region",
      headingPre: "Wood from all corners of the ",
      headingItalic: "world",
      headingPost: ".",
      desc: "From Africa to the Far East, discover our timber selection from four continents by region.",
    },
    featured: {
      label: "Collection",
      headingPre: "Our product ",
      headingItalic: "groups",
      dragHint: "Drag or swipe",
      viewAll: "View All",
    },
    contact: {
      label: "Contact",
      headingPre: "Let's work ",
      headingItalic: "together.",
      email: "E-mail",
      phone: "Phone",
      whatsapp: "WhatsApp",
      address: "Address",
      openMap: "Open in Maps",
      waMessage: "Hello, I would like to get information about your products.",
      formTitle: "Write to Us",
      formDesc: "Send your request and we will get back to you shortly.",
    },
    thanks: {
      label: "Message Received",
      heading: "Thank ",
      headingItalic: "You",
      greeting: (name) => (name ? `Dear ${name},` : ""),
      body: "Your request has reached us safely. Our team is reviewing your message and will get back to you as soon as possible.",
      note: "For urgent requests, you can also reach us by phone or WhatsApp.",
      home: "Back to Home",
      explore: "Explore Products",
      whatsapp: "Chat on WhatsApp",
    },
    trust: {
      label: "Trust & Quality",
      heading: "Certified ",
      headingItalic: "Quality",
      desc: "With our FSC-certified supply chain and registered trademarks, every product we deliver is backed by documented quality assurance.",
      cta: "View Certificates",
      p1t: "FSC Certified",
      p1d: "Certified sourcing from responsibly managed forests.",
      p2t: "Registered Trademarks",
      p2d: "İnter Orman and Vinterio are delivered under registered trademark assurance.",
      p3t: "Import & Export",
      p3d: "A strong supply and distribution network from the Far East to Europe.",
      p4t: "Quality Control",
      p4d: "Every batch passes rigorous quality inspection before shipment.",
    },
    form: {
      name: "Your Name",
      namePh: "Enter your name",
      email: "E-mail",
      emailPh: "example@email.com",
      message: "Your Message",
      messagePh: "Write your request here...",
      send: "Send Message",
      sending: "Sending...",
      fillAll: "Please fill in all fields.",
      success: "Your message has been received. We will get back to you shortly.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "Timber & Wood Veneer Import",
      certificates: "Certificates",
      rights: "All rights reserved.",
      admin: "Admin",
      kvkk: "Personal Data Retention and Disposal Policy",
    },
    search: {
      label: "Search Products",
      placeholder: "Type a product name, category or series...",
      triggerText: "Search products — Oak, Walnut, Teak...",
      triggerBtn: "Search",
      loading: "Loading products...",
      searchIn: (n) => `Search among ${n} products`,
      results: (n, plus) => `${n} result${n === 1 ? "" : "s"}${plus ? "+" : ""}`,
      noResults: (q) => `No results for "${q}". Try a different keyword.`,
    },
    lightbox: {
      special: "Special Collection",
      noDesc: "No description has been added for this product yet.",
      quote: "Get a Quote",
      pdf: "Download PDF",
      quoteSub: "Quickly request a quote for this product.",
      quoteSubPlywood: "Quickly request a quote for this plywood.",
      waButton: "Get a Quote via WhatsApp",
      waSelect: "Choose a WhatsApp line",
      orForm: "or fill out the form",
      direct: "Direct contact",
      waMessage: (name) => `Hello, I would like to get a quote for "${name}".`,
      quotePrefill: (name) => `Quote request: ${name}`,
      zoomIn: "Inspect the texture",
      zoomOut: "Zoom out",
    },
    category: {
      products: "Products",
      tone: "Color Tone",
      cut: "Cut",
      empty: "No products have been added to this category yet.",
      noResults: "No products match this selection.",
    },
    certs: { empty: "Certificates will be added soon." },
    kontrplak: {
      heroSub: "Wood Plywood",
      heroTitle: "Plywood",
      heroDesc: "Lightweight, durable and marine-grade plywood varieties — choose the right solution for your projects.",
      compareLabel: "Quick Comparison",
      compareHeading: "Which plywood is right for you?",
      thType: "Type",
      thWeight: "Weight",
      thWater: "Water Resistance",
      thSize: "Standard Size",
      size: "Size",
      features: "Features",
      uses: "Applications",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem("lang") || "tr"; } catch { return "tr"; }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    try { localStorage.setItem("lang", l); } catch {}
    setLangState(l);
  };

  const t = (key, ...args) => {
    const get = (obj) => key.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);
    let v = get(STR[lang]);
    if (v == null) v = get(STR.tr);
    return typeof v === "function" ? v(...args) : v ?? key;
  };

  const dn = (value) => (lang === "en" && NAMES_EN[value]) || value;

  return <LangContext.Provider value={{ lang, setLang, t, dn }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const DISPLAY_EN = NAMES_EN;

export const productGroupLabel = (p, dn) =>
  dn(p.subcategory ? p.subcategory : (p.category === "Kaplama" ? "Doğal Kaplama" : p.category));

export const productDesc = (p, lang) =>
  lang === "en" && p.description_en ? p.description_en : p.description;
